/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import HashLoader from "react-spinners/HashLoader";
import { store } from "./components/redux/store";
import { Toaster } from "react-hot-toast";
import { SocketProvider } from "./components/redux/socket/socketProvider";
import { I18nextProvider } from "react-i18next";
import i18n from "./components/language/i8n";

const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense
    fallback={
      <main className="h-screen flex flex-col justify-center items-center">
        <HashLoader color="#9F1E24" />
      </main>
    }
  >
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <BrowserRouter>
          <React.StrictMode>
            <SocketProvider>
              <App />
              <Toaster />
            </SocketProvider>
          </React.StrictMode>
        </BrowserRouter>
      </Provider>
    </I18nextProvider>
  </Suspense>
);

reportWebVitals();
